module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.4-128.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.6.4.md
// module id = 544
// module chunks = 257